export default __webpack_public_path__ + "441c3fe8eef9b08bc007d42e07b7352c.png";